'use client';

import React, { useEffect, useState } from 'react';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: any;
  
}
export default function ImageComponent({ src, fallbackSrc, ...props }: ImageProps) {
  const [currentSrc, setCurrentSrc] = useState(fallbackSrc);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setCurrentSrc(src);
    };
  }, [src]);

  return <img src={currentSrc} {...props} />;
}